import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import Button from '../../../../component/Button';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import UserInformation from './UserInformation';
import PersonalInformation from './PersonalInformation';
import DealersTable from './DealersTable';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';
import SuccessModal from '../../../../modalComponents/SuccessModal';
import ReasonModal from '../../../../modalComponents/ReasonModal';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { UserRoleID } from '../../../../helpers';
import AuthorizedUser from './AuthorizedUser';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import AddTarget from '../../../../modalComponents/AddTarget';

const UserDetails = (props) => {
    const { viewData, userId, currentTab } = props
    const [showVerifyPopUp, setShowVerifyPopUp] = useState(false)
    const [showDeclinePopUp, setShowDeclinePopUp] = useState(false)
    const [showReasonPopUp, setShowReasonPopUp] = useState(false)
    const [showTargetPopUP, setShowTargetPopUp] = useState(false)
    const [userInfo, setUserInfo] = useState(null)
    const [isEdit, setIsEdit] = useState(false);
    const activeTab = currentTab
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const location = useLocation()

    useEffect(() => {
        getUserDetails()
        const timer = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
        return () => clearTimeout(timer);
    }, [])

    const getUserId = () => {
        const pathName = location?.search?.split("?id=");
        const params = pathName?.length > 1 ? pathName[pathName?.length - 1] : null;
        return params;
    };

    const getUserDetails = async () => {
        let url = `${Exported.Endpoints.getUserDetails}`
        let paramsObj = {
            user_id: userId,
            // user_role: UserRoleID[viewData?.userRole],
        }
        // if (viewData?.userRole == 'AuthorizedUser') {
        //     paramsObj['retailer_id'] = 2
        // }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setUserInfo(res?.data?.data)
            } else {
                setUserInfo(null)
            }
        }).catch((err) => {
            console.log(err, "err")
            setUserInfo(null)
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const handleVerify = async () => {
        let url = `${Exported.Endpoints.updateRetailStatus}`
        let paramsObj = {
            userId: userId,
            reason: '',
            isVerified: true
        }
        dispatch(saveLoadingState(true))
        let successResponse = false
        await request({
            url: url,
            method: Exported.APIMethods.POST,
            data: {
                ...paramsObj
            }
        }).then((res) => {
            if (res?.data?.status) {
                successResponse = true
            } else {
                successResponse = false
            }
        }).catch((err) => {
            console.log(err, "err")
            successResponse = false
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        if (successResponse) {
            setShowVerifyPopUp(true)
        }
        dispatch(saveLoadingState(false))
        redirectBack()

    };

    const redirectBack = () => {
        navigate('/admin/users')
    }

    const handleClose = () => {
        setShowDeclinePopUp(false)
    }

    const handleReasonClose = () => {
        setShowReasonPopUp(false)
    }

    const handleVerifyClose = () => {
        setShowVerifyPopUp(false)
    }

    const declineUser = () => {
        setShowDeclinePopUp(false)
        setShowReasonPopUp(true)
    }

    const handleTarget = () => {
        setShowTargetPopUp(true)
    }

    const closeTargetModal = () => {
        setShowTargetPopUp(false)
    }

    const handleSetTargetSuccess = () => {
        setShowTargetPopUp(false)
        navigate('/admin/users')
    }

    return (
        <>
            <div className={`${classes.userInfoWrapper}`}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title flex items-center`}>
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>User Details</div>
                    </div>
                    <div>
                        {
                            activeTab === "Verified Retailers" ?
                                <Button text={"Set Target"} className={`!w-[150px]`} smallBtn onClick={() => handleTarget()} />
                                : null
                        }

                        {
                            userInfo?.user?.approvedByAdmin === null ?
                                (activeTab === "All Users" || activeTab === "Incomplete Retailer" || activeTab === "Incomplete Mechanic") ? null
                                    :
                                    <>
                                        <Button text={"Decline"} className={`mr-4 ml-4 !w-[150px]`} smallBtn secondary onClick={() => setShowDeclinePopUp(true)} />
                                        <Button text={"Verify"} className={`!w-[150px]`} smallBtn onClick={() => handleVerify()} />
                                    </>
                                : null
                        }
                    </div>
                </div>
                <div className='my-8'>
                    <UserInformation userInfo={userInfo?.user} slotsBooked={userInfo?.userInfo?.slotsBooked} />
                    <PersonalInformation facilityPhotos={userInfo?.userInfo?.facilityPhotos?.documents} documents={userInfo?.userInfo?.identity?.documents}
                        businessInfo={userInfo?.userInfo?.businessInfo}
                        companyInfo={userInfo?.userInfo?.companyInfo}
                        contactInfo={userInfo?.userInfo?.contactInfo}
                    />
                    {/* <DealersTable /> */}
                    {userInfo?.userInfo?.rusers?.length > 0 ?
                        <AuthorizedUser userData={userInfo?.userInfo?.rusers} /> : null
                    }
                </div>
            </div>
            {showDeclinePopUp ?
                <ConfirmationModal
                    isOpen={showDeclinePopUp}
                    handleSuccess={declineUser}
                    closePopUp={handleClose}
                    warningText={'Confirmation'}
                    modalText={'Kindly provide the confirmation for declining the retailer’s request'}
                    confirmText={'Decline'}
                    cancelText={'Back'}
                    primaryBtnConfirm={false}
                />
                : null
            }
            {showReasonPopUp ?
                <ReasonModal isOpen={showReasonPopUp} closePopUp={handleReasonClose} userId={userId} />
                : null}
            {showVerifyPopUp ?
                <SuccessModal
                    isOpen={showVerifyPopUp}
                    closePopUp={handleVerifyClose}
                    successText={'Verified'}
                    modalText={'New retailer’s request has been successfully verified.'}
                />
                : null
            }
            {showTargetPopUP ? (
                <AddTarget
                    isOpen={showTargetPopUP}
                    closePopUp={closeTargetModal}
                    handleSuccessModal={handleSetTargetSuccess}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    id={getUserId()}
                    value={userInfo?.user?.membership_points || ''}
                />
            ) : null}
        </>
    )
}

export default UserDetails